import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  keyUp(e) {
    this.detectCardType(e)
  }

  focusOut(e) {
    this.detectCardType(e)
  }

  detectCardType(e) {
    let input = e.target

    let cardNumber = input.value;
    let cardType = GetCardType(cardNumber).toLowerCase();

    $(".card-number-input.card-logo").addClass("hide")

    if (cardType !== 'invalid' && checkCreditCard(cardNumber, cardType)) {
      if (cardType === 'visa') {
        $("#card-logo-visa").removeClass("hide")
      } else if (cardType === 'mastercard') {
        $("#card-logo-mastercard").removeClass("hide")
      } else if (cardType === 'amex') {
        $("#card-logo-amex").removeClass("hide")
      }
    }
    else {
      $('#cardNumber').css('background', '');
    }
  }
}